module.exports = __webpack_public_path__ + "img/dashboard-card-1.44d12d6a.svg";